import Firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import {
    getStorage
} from 'firebase/storage';
import "firebase/auth";
const firebaseConfig = {
apiKey: "AIzaSyB4Rw_04S085fFLDFhDuR9ZVitR12rWBF4",
  authDomain: "gorillatravel-5f7cb.firebaseapp.com",
  projectId: "gorillatravel-5f7cb",
  storageBucket: "gorillatravel-5f7cb.firebasestorage.app",
  messagingSenderId: "342154876632",
  appId: "1:342154876632:web:e9e0ef09415d3b64b3a9ad",
  measurementId: "G-B9VZDNPWY4"
};



const Appconnection = Firebase.initializeApp(firebaseConfig);

const Dbconn = Appconnection.firestore();
export const Storage = getStorage(Appconnection);
export {
    Dbconn
};